export default {
  title: 'My Tools',
  description:
    'Build a customized marketing solution in minutes using these features!',
  disclaimer: {
    default:
      '{features} resources are only available for businesses with <b>online operations</b>.',
    notUSA:
      '{features} resources are only available for businesses with <b>online operations in the USA</b>.'
  },
  blockedText: {
    reward:
      'You need to set up your <span>Online Loyalty Rewards Program</span> to unlock this tool.',
    provider: 'You need to <span>connect an online provider</span> first.'
  }
};
